import React from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { AppState, RootState, Dispatcher } from 'AppTypes'

import { toggleMainAppSidebarOpen } from '@app/state_management/actions'

type Props = {
  appState: AppState
  dispatch: Dispatcher
}

const Overlay: React.FC<Props> = ({
  appState: {
    isMainAppSidebarOpen
  },
  dispatch
}) => {
  const dispatchToggleMainAppSidebarOpen = () => dispatch(toggleMainAppSidebarOpen(!isMainAppSidebarOpen))
  const overlayClasses = classNames({
    overlay: true,
    active: isMainAppSidebarOpen
  })

  return (
    <div
      aria-hidden="true"
      className={overlayClasses}
      onClick={dispatchToggleMainAppSidebarOpen}
    />
  )
}

export default connect((state: RootState) => ({
  appState: state.app
}))(Overlay)
